export const settings = {
  setShareTitle: 'Compartir aplicación',
  setNotifiationsTitle: 'Notificaciones',
  setContactAppOwnerTitle: 'Contactar al propietario de la aplicación',
  setContactDevelopersTitle: 'Contactar a los desarrolladores',
  setReportAppTitle: 'Reportar aplicación',
  setDeleteAccountTitle: 'Eliminar cuenta',
  setLogOutTitle: 'Cerrar sesión',
  setShareAppCurtainTitle: 'Compartir aplicación',
  setShareAppCurtainButtonTitle: 'Copiar enlace',
  setShareAppAlertWhenAppLinkWasCopied: '¡Enlace copiado!',
  setNotificationsInAppTitle: 'En la aplicación',
  setNotificationsPushContent: 'Push',
  setNotificationsChatsTitle: 'Chats',
  setNotificationsDiscussionsTitle: 'Discusiones',
  setNotificationsNewsTitle: 'Noticias',
  setNotificationsEventsTitle: 'Eventos',
  setNotificationsAdminTitle: 'Mensajes de administrador',
  setNotificationsBlogTitle: 'Blog',
  setNotificationsPushOffContent: 'Las notificaciones push están desactivadas',
  setNotificationsPushOffText:
    'Para habilitar las notificaciones, por favor, ve a la configuración de tu dispositivo y activa las notificaciones',
  setReportAppFlagCurtainTitle: 'Reportar',
  setAppReportedCurtainContent: 'Contenido reportado',
  setDeleteCurtainTitle: 'Eliminar cuenta',
  setDeleteCurtainInputContent: 'Contraseña',
  setDeleteCurtainCancelButtonTitle: 'Cancelar',
  setDeleteCurtainConfirmButtonTitle: 'Confirmar',
  setDeleteCurtainIncorrectPasswordAlertText: 'Contraseña incorrecta',
  setTurnNotificationsOnText: 'Para activarlas, por favor, haz clic en el botón de abajo y permite recibir notificaciones.',
  setTurnNotificationsOnButton: 'Activar notificaciones push'
}
